module.exports = __webpack_public_path__ + "img/logos_ita.aa86fb78.png";